module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-loader"
  }, [_c('p', [_vm._v("loading")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.progressSerialized))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b6e0d04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader/Loader.vue
// module id = 91
// module chunks = 2